import React from 'react'
import classNames from 'classnames'
import {MainListTitle} from '../../main-list-title'
import {LoadMoreButton} from '../../load-more-button'
import {useWidgetState} from '../../../hooks/state-provider'
import {getEvents, hasMoreEvents} from '../../../selectors/events'
import {ListItemContainer} from '../../event-container/list-item-container'
import {isMobile} from '../../../../../../commons/selectors/environment'
import {getComponentConfig, isListLayout} from '../../../selectors/settings'
import s from './compact-mobile.scss'
import {CompactMobileItem} from './compact-mobile-item'

export const CompactMobile = () => {
  const mobile = useWidgetState(isMobile)
  const events = useWidgetState(getEvents)
  const hasMore = useWidgetState(hasMoreEvents)
  const componentConfig = useWidgetState(getComponentConfig)
  const isDesktopListLayout = isListLayout(componentConfig)
  const className = classNames(s.container, isDesktopListLayout ? s.listContainer : s.cardContainer)

  return (
    <div className={className} data-hook="ev-list-layout">
      <MainListTitle />
      <ul>
        {events.map((event: ExtendedEvent, index: number) => (
          <ListItemContainer
            key={event.id}
            event={event}
            hideDivider={events.length - 1 === index && !hasMore}
            mobile={mobile}
            cardDivider={!isDesktopListLayout}
          >
            {() => <CompactMobileItem event={event} />}
          </ListItemContainer>
        ))}
      </ul>
      <LoadMoreButton mobile />
    </div>
  )
}
